module.exports = __webpack_public_path__ + "img/矩形 30 拷贝 5@2x(1).2da48c99.png";